import { createRouter, createWebHistory, createMemoryHistory } from 'vue-router'
import Home from '../views/home.vue'

import about from '@/content/about.yml'
import turnKeyForCRCs from '@/content/turnKeyForCRCs.yml'
import turnKeyForRDCs from '@/content/turnKeyForRDCs.yml'
import turnKeyForResMan from '@/content/turnKeyForResMan.yml'
//import contact from '@/content/contact.yml'

// Define navigation structure
export const navigation = {
  mainNav: [
    {
      name: 'Home',
      path: '/',
      component: Home
    },
    {
      name: about.head.menuTitle,
      path: '/' + about.head.slug,
      component: () => import('../views/about.vue')
    },
    /** Adding as replacement for Services */
    {
      name: 'Services',
      path: '/services',
      component: () => import('../views/turnKeyCRCs.vue')
    },
    {
      name: 'For research centres, institutes and organisations',
      path: '/services/for-research-management',
      menu: false,
      component: () => import('../views/turnKeyResMan.vue')
    }
    /** Removed for Launch
    {
      name: 'Services',
      path: '/services',
      children: [
        {
          name: turnKeyForCRCs.head.menuTitle,
          path: turnKeyForCRCs.head.slug,
          component: () => import('../views/turnKeyCRCs.vue')
        },
        {
          name: 'For RDCs',
          path: 'for-rdcs',
          component: () => import('../views/turnKeyRDCs.vue')
        },
        {
          name: 'For research centres, institutes and organisations',
          path: 'for-research-management',
          component: () => import('../views/turnKeyResMan.vue')
        }
      ]
    },
    {
      name: 'Contact',
      path: '/contact',
      component: () => import('../views/contact.vue')
    }
    **/
  ],
  footerNav: [
    {
      name: 'Privacy Policy',
      path: '/privacy'
    },
    {
      name: 'Terms of Service',
      path: '/terms'
    },
    {
      name: 'Sitemap',
      path: '/sitemap'
    }
  ]
}

// Create routes from navigation
const routes = navigation.mainNav.map(item => {
  if (item.children) {
    // For services, create direct routes for each child
    return item.children.map(child => ({
      path: `/${item.path}/${child.path}`,
      name: child.name,
      component: child.component
    }))
  }
  return {
    path: item.path,
    name: item.name,
    component: item.component
  }
}).flat() // Flatten the array to handle the services routes

export const createRouterInstance = (isClient = false) => {
  return createRouter({
    history: isClient ? createWebHistory() : createMemoryHistory(),
    routes/**,
    scrollBehavior(to, from, savedPosition) {
      // Always scroll to top on route change
      console.log('scrolling to top')
      return { top: 0 }
    }**/
  })
  
}

